module.exports = {
  console: true,
  prettyStream: false,
  filePath: `${process.cwd()}/logs/application-{{app}}-{{port}}.log`,
  internalLoggerFilePath: `${process.cwd()}/logs/application-il-{{app}}-{{port}}.log`,
  consoleOverrides: [],
  ringBufferLimit: 100,
  rotateDepth: 5,
  rotatePeriod: '1d',
  level: 'debug',
  serializers: {},
};

